import React, { FC, useState } from 'react'

import { CardWrapper } from '../CardWrapper/CardWrapper'
import { CardItem } from '../CardItem/CardItem'

import {
  getPaperworkDate,
  getVaccinationDate,
  isExpiredPaperwork,
  isExpiredVaccination,
} from '../../../../../../helpers/requiredFields'
import { useProfile } from '../../../../../../hooks/useProfile'

import { IHorseCompetitorDocument } from '../../../../../../models/horse-competiton-paperwork/horse-competiton-paperwork-interface'
import { IHorsesWithPaperwork } from '../../tabs/HorsesTab/HorsesTab'

interface PaperworkCardProps {
  index: number
  paperwork: IHorseCompetitorDocument | null
  horsesWithPaperwork: IHorsesWithPaperwork[]
  setHorsesWithPaperwork: (state: IHorsesWithPaperwork[]) => void
  isEditable?: boolean
}

export const PaperworkCard: FC<PaperworkCardProps> = ({
  index,
  horsesWithPaperwork,
  setHorsesWithPaperwork,
  paperwork,
  isEditable,
}) => {
  const { onSaveEditHorse, onCancelEditHorse, onChangeHorseInput } = useProfile()

  const [isEdit, setIsEdit] = useState(false)

  return (
    <CardWrapper
      title="Paperwork"
      onSaveEdit={() => onSaveEditHorse({ index, horsesWithPaperwork, setIsEdit })}
      onCancelEdit={() =>
        onCancelEditHorse({ index, horsesWithPaperwork, setHorsesWithPaperwork, setIsEdit })
      }
      isEditable={isEditable}
      isEdit={isEdit}
      setIsEdit={setIsEdit}
    >
      <CardItem
        fieldType="paperwork"
        fieldKey="horseCoggins"
        label="Coggins"
        defaultValue={getPaperworkDate(paperwork?.cogginsInspectionDate || null)}
        url={paperwork?.cogginsCertificate?.[0]}
        isInvalid={!paperwork?.cogginsInspectionDate || !paperwork?.cogginsCertificate?.[0]}
        isMissing={!paperwork?.cogginsCertificate?.[0]}
        isExpired={isExpiredPaperwork(paperwork?.cogginsInspectionDate)}
        showLabelError={true}
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeHorseInput({
            fieldName,
            fieldType,
            fieldKey,
            option,
            index,
            horsesWithPaperwork,
            setHorsesWithPaperwork,
          })
        }
      />
      <CardItem
        fieldType="paperwork"
        fieldKey="horseHealthCertificate"
        label="Health certificate"
        defaultValue={getPaperworkDate(paperwork?.healthInspectionDate || null)}
        url={paperwork?.healthCertificate?.[0]}
        isInvalid={!paperwork?.healthInspectionDate || !paperwork?.healthCertificate?.[0]}
        isMissing={!paperwork?.healthCertificate?.[0]}
        isExpired={isExpiredPaperwork(paperwork?.healthInspectionDate)}
        showLabelError={true}
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeHorseInput({
            fieldName,
            fieldType,
            fieldKey,
            option,
            index,
            horsesWithPaperwork,
            setHorsesWithPaperwork,
          })
        }
      />
      <CardItem
        fieldType="paperwork"
        fieldKey="vaccinationCertificate"
        label="Vaccination records"
        defaultValue={getVaccinationDate(paperwork?.vaccinationInspectionDate || null)}
        url={paperwork?.vaccinationCertificate?.[0]}
        isInvalid={!paperwork?.vaccinationInspectionDate || !paperwork?.vaccinationCertificate?.[0]}
        isMissing={!paperwork?.vaccinationCertificate?.[0]}
        isExpired={isExpiredVaccination(paperwork?.vaccinationInspectionDate)}
        showLabelError={true}
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeHorseInput({
            fieldName,
            fieldType,
            fieldKey,
            option,
            index,
            horsesWithPaperwork,
            setHorsesWithPaperwork,
          })
        }
      />
      <CardItem
        fieldType="paperwork"
        fieldKey="horseRhinopneumonitis"
        label="Rhinopneumonitis"
        defaultValue={getVaccinationDate(paperwork?.rhinopneumonitisInspectionDate || null)}
        url={paperwork?.rhinopneumonitisCertificate?.[0]}
        isInvalid={
          !paperwork?.rhinopneumonitisInspectionDate || !paperwork?.rhinopneumonitisCertificate?.[0]
        }
        isMissing={!paperwork?.rhinopneumonitisCertificate?.[0]}
        isExpired={isExpiredVaccination(paperwork?.rhinopneumonitisInspectionDate)}
        showLabelError={true}
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeHorseInput({
            fieldName,
            fieldType,
            fieldKey,
            option,
            index,
            horsesWithPaperwork,
            setHorsesWithPaperwork,
          })
        }
      />
      <CardItem
        fieldType="paperwork"
        fieldKey="horseInfluenza"
        label="Influenza"
        defaultValue={getVaccinationDate(paperwork?.influenzaInspectionDate || null)}
        url={paperwork?.influenzaCertificate?.[0]}
        isInvalid={!paperwork?.influenzaInspectionDate || !paperwork?.influenzaCertificate?.[0]}
        isMissing={!paperwork?.influenzaCertificate?.[0]}
        isExpired={isExpiredVaccination(paperwork?.influenzaInspectionDate)}
        showLabelError={true}
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeHorseInput({
            fieldName,
            fieldType,
            fieldKey,
            option,
            index,
            horsesWithPaperwork,
            setHorsesWithPaperwork,
          })
        }
      />
    </CardWrapper>
  )
}
